import React, { useRef } from "react";
import Index from "../../../component/Index";
import { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { DataService } from "../../../config/DataService";
import { API } from "../../../config/Api";
import { toast } from "react-toastify";
const BuyModel = ({ open, handleClose, marketDetails, tokenBalance }) => {
  const token = useSelector((state) => state.user.userToken);

  const [buyAmount, setBuyAmount] = useState(0);
  console.log(tokenBalance, "pricedfasfv");

  const formikRef = useRef();

  const handleCloseModal = () => {
    formikRef.current.resetForm();
    setBuyAmount(0);
    handleClose();
  };
  const WithdrawCryptoSchema = Yup.object().shape({
    quantity: Yup.number().required("Please enter quantity"),
    amount: Yup.number()
      .min(20, "minimum amount 20")
      .test("checkBalance", "Amount exceeds token balance", function (value) {
        if (value === null || value === undefined) {
          return true;
        }
        return value <= tokenBalance;
      }),
  });
  const handleFormSubmit = (values) => {
    getBuyData(values.amount);
  };

  const getBuyData = async (amount) => {
    const data = new URLSearchParams();
    data.append("amount", amount);
    data.append("token_name", marketDetails.name);
    await DataService(token)
      .post(API.Exchange.BUY_TOKEN, data)
      .then((res) => {
        if (res?.data?.status === 200) {
          toast.success(res?.data?.message);
          console.log(res);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };
  const calculateQuantityAndTotal = (quantity, setFieldValue) => {
    console.log(quantity, 55);
    const tokenPrice = marketDetails.token_price;
    const transactionChargePercentage = 1;
    const calculatedAmount = quantity * tokenPrice;
    const transactionCharge =
      (calculatedAmount * transactionChargePercentage) / 100;
    const total = calculatedAmount + transactionCharge;
    setFieldValue("amount", calculatedAmount.toFixed(2));

    setBuyAmount(total);
  };
  return (
    <Index.Dialog fullWidth maxWidth="xs" open={open} className="dialog-box">
      <Formik
        initialValues={{
          amount: "",
          quantity: "",
          transactionFees: "1%",
        }}
        validationSchema={WithdrawCryptoSchema}
        onSubmit={handleFormSubmit}
        innerRef={formikRef}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
        }) => (
          <Form onSubmit={handleSubmit} className="modal-form">
            {console.log(errors, 555)}

            <Index.DialogTitle className="dialog-title">
              Buy Token
              <Index.CloseIcon
                className="model-close-icon"
                onClick={handleCloseModal}
              />
            </Index.DialogTitle>
            <Index.Box
              gridColumn={{
                xs: "span 12",
                sm: "span 6",
                md: "span 6",
                lg: "span 6",
              }}
              className="grid-column"
            >
              <Index.Box className="input-box">
                <Index.FormHelperText className="form-lable">
                  Quantity
                </Index.FormHelperText>
                <Index.Box className="form-group">
                  <Index.TextField
                    id="fullWidth"
                    name="quantity"
                    fullWidth
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    className="form-control"
                    placeholder=""
                    autocomplete="off"
                    onBlur={handleBlur}
                    value={values.quantity}
                    onChange={(e) => {
                      const quantity = e.target.value;
                      setFieldValue("quantity", quantity);
                      calculateQuantityAndTotal(quantity, setFieldValue);
                    }}
                    helperText={touched.quantity && errors.quantity}
                    error={Boolean(errors.quantity && touched.quantity)}
                  />
                </Index.Box>
              </Index.Box>
            </Index.Box>
            <Index.Box
              gridColumn={{
                xs: "span 12",
                sm: "span 6",
                md: "span 6",
                lg: "span 6",
              }}
              className="grid-column"
            >
              <Index.Box className="input-box">
                <Index.FormHelperText className="form-lable">
                  Amount
                </Index.FormHelperText>
                <Index.Box className="form-group">
                  <Index.TextField
                    id="fullWidth"
                    disabled
                    fullWidth
                    name="amount"
                    className="form-control"
                    placeholder=""
                    autocomplete="off"
                    onBlur={handleBlur}
                    value={values.amount}
                    helperText={touched.amount && errors.amount}
                    error={Boolean(errors.amount && touched.amount)}
                  />
                </Index.Box>
              </Index.Box>
            </Index.Box>

            <Index.Box
              gridColumn={{
                xs: "span 12",
                sm: "span 12",
                md: "span 12",
                lg: "span 12",
              }}
              className="grid-column"
            >
              <Index.Box className="input-box">
                <Index.Box className="available-token-sec">
                  <Index.Typography
                    className="available-titles"
                    variant="p"
                    component="p"
                  >
                    Total Payable Amount <br />{" "}
                    {buyAmount ? buyAmount?.toFixed(2) : 0}
                  </Index.Typography>
                  <Index.Typography
                    className="available-data"
                    variant="p"
                    component="p"
                  >
                    Transaction Fees : <br /> 1%
                  </Index.Typography>
                </Index.Box>
              </Index.Box>
            </Index.Box>
            <Index.Box
              gridColumn={{
                xs: "span 12",
                sm: "span 12",
                md: "span 12",
                lg: "span 12",
              }}
              className="grid-column"
            >
              <Index.Box className="input-box">
                <Index.Box className="available-token-sec">
                  <Index.Typography
                    className="available-titles"
                    variant="p"
                    component="p"
                  >
                    Available Balance
                  </Index.Typography>
                  <Index.Typography
                    className="available-data"
                    variant="p"
                    component="p"
                  >
                    {tokenBalance ? tokenBalance.toFixed(2) : 0}
                  </Index.Typography>
                </Index.Box>
              </Index.Box>
            </Index.Box>
            <Index.Box className="sub-tab-buttons">
              <Index.Button
                className="trading-btns buttons trade-buttons"
                variant="contained"
                type="submit"
                fullWidth
              >
                Buy
              </Index.Button>
            </Index.Box>
          </Form>
        )}
      </Formik>
    </Index.Dialog>
  );
};

export default BuyModel;
